<template>
  <div class="w-full flex justify-center">
    <div class="lg:w-3/5 bg-grey-lightest md:p-4 rounded">
      <div class="w-full flex justify-center mt-4">
        <div class="w-full flex justify-center md:flex-row lg:flex-row xl:flex-row">
          <h1 class="bg-blue-darker px-4 py-2 text-2xl md:text-4xl rounded text-white">Prijzen zijn op aanvraag</h1>
        </div>
      </div>
      <div class="w-full flex justify-around items-around text-sm md:text-md">
        <div class="flex justify-start flex-col items-center py-4 px-2 my-2 bg-blue rounded-tl rounded-bl text-grey-lightest leading-loose text-center">
          <h3 v-responsive.sm.xs class="bg-blue-darker px-4 text-sm md:text-lg rounded-full">
              Evt. meerprijzen
          </h3>
          <h3
            v-responsive.md.lg.xl
            class="bg-blue-darker px-4 text-sm md:text-lg rounded-full"
          >Prijzen</h3>
          <ul v-if="content.block1.items" style="text-align: left;">
            <li v-for="item in content.block1.items" v-bind:key="item">
              <i class="fas fa-angle-right text-blue-lighter"></i>
              {{item}}
            </li>
          </ul>
        </div>
        <div
          class="flex justify-start flex-col items-center py-4 px-2 my-2 bg-blue-dark rounded-tr rounded-br text-grey-lightest leading-loose text-center"
        >
          <h3
            v-if="content.block2.title"
            class="bg-blue-darker px-4 text-sm md:text-lg rounded-full"
          >{{content.block2.title}}</h3>
          <ul v-if="content.block2.items" style="text-align: left;">
            <li v-for="item in content.block2.items" v-bind:key="item">
              <i class="fas fa-angle-right text-blue-lighter"></i>
              {{item}}
            </li>
          </ul>
        </div>
      </div>
      <div class="w-full flex justify-around items-around text-sm md:text-md">
        <div
          class="flex justify-start flex-col items-center py-4 px-2 my-2 bg-blue-light rounded-tl rounded-bl text-grey-lightest leading-loose text-center"
        >
          <h3 class="bg-blue-darker px-4 text-sm md:text-lg rounded-full">{{content.block3.title}}</h3>
          <ul style="text-align: left;">
            <li v-for="item in content.block3.items" v-bind:key="item">
              <i class="fas fa-angle-right text-blue-lighter"></i>
              {{item}}
            </li>
          </ul>
        </div>
      </div>
      <div class="w-full flex justify-around items-around text-sm md:text-md">
        <div
          class="flex justify-center flex-col items-center py-4 px-2 my-2 bg-blue-dark rounded-tr rounded-br text-grey-lightest leading-loose text-center"
        >
          <h3
            v-if="content.block4.title"
            class="bg-blue-darker px-4 text-sm md:text-lg rounded-full"
          >{{content.block4.title}}</h3>
          <ul v-if="content.block4.items" style="text-align: left;">
            <li v-for="item in content.block4.items" v-bind:key="item">
              <i class="fas fa-angle-right text-blue-lighter"></i>
              {{item}}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PricingComponent",
  props: ["contents"],
  data() {
    return {
      content: {
        block1: {
          title: "Eventuele meerprijzen",
          items: [
            "Meerprijs voor vloerverwarming op krimpnet met alu + folie",
            "Meerprijs voor stadsverwarming",
            "Er wordt een meerprijs gerekend voor nieuwbouw als er nog een dekvloer gestort moet worden",
            "Frezen in fermacel",
            "Frezen in tegevloer (indien mogelijk)"
          ]
        },
        block2: {
          title: "Over de prijzen",
          items: [
            "De prijzen zijn exclusief parkeer- en eventuele reiskosten.",
            "Vloerverwarming wordt standaard uitgevoerd met een 5-lagenbuis in een slakkenhuispatroon.",
            "Stalen compact verdeler met het A-label pomp met 2 jaar fabrieksgarantie",
            "Betalingen worden binnen 8 dagen na oplevering verwacht"
          ]
        },
        block3: {
          title: "Vereisten voor infrezen",
          items: [
            "Bij het aansluiten van vloerverwarming op de cv-installatie dient er binnen een meter vanaf de verdeler een aansluitpunt te zijn",
            "De vloer dient een vlakke en gladde dekvloer te hebben",
            "Vloeren waar bijvoorbeeld tegels of parket is afgehakt meoten voor het frezen ge\u00ebgaliseerd worden",
            "Aansluiten op dikwandige installaties moet vooraf gemeld worden, eventuele meerkosten worden doorberekend",
            "De verdeler mag nooit in de meterkast geplaatst worden"
          ]
        },
        block4: {
          title: "Niet inbegrepen in de prijs",
          items: [
            "Risico doorfrezen of boren van bestaande leidingen in de dekvloer",
            "Demonteren van radiatoren, afdoppen leidingen",
            "Monteren van het stopcontact ten behoeve van de vloerverwarmingsverdeler",
            "Afvoeren van freesstof en dichten van sleuven"
          ]
        }
      }
    };
  }
};
</script>

<style scoped>
#bg-front {
  filter: contrast(80%);
  height: 12rem;
  background-size: 100%;
  background: url("https://images.pexels.com/photos/990818/pexels-photo-990818.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260")
    no-repeat 0;
}
</style>
